import { Box } from '@mui/material';
import React from 'react'

interface WrapperContainerProps {
    children?: React.ReactNode;
}

const WrapperContainer = ({ children }: WrapperContainerProps) => {
    return (
        <Box className="border-b-[1px] border-gray_10 md:px-8 lg:px-0 gap-14 xl:flex xl:justify-center">
            <Box className="px-5 py-12 lg:px-11 border-b-[1px] gap-14 grid lg:flex md:w-full xl:justify-between 2xl:gap-14 xl:max-w-[1352px] xl:w-full">
                {children}
            </Box>
        </Box>
    )
}

export default WrapperContainer